import {localizePath, t} from "../../../i18n";
import {Link} from "react-router";
import ProgressiveImage from '../../../commonComponent/image/ProgressiveImage';
import SectionPanel, {SectionCopy} from '../../../commonComponent/section/SectionPanel';
import {imageAssets} from '../../../assets/imageAssets';
import restaurantInfo from "../../../data/restaurant.json";

const CardSection = () => { return (
    <section data-reveal className="content-row card-row">
        <article className="image-surface card-discovery">
            <ProgressiveImage asset={imageAssets.cardSection} sizes="(max-width: 639px) 100vw, 50vw"
                              alt={t("altCardSection")} className="surface-image"/>
            <Link to={localizePath("/carte")} className="ui-button ui-button--on-image"> {t("home.discover")} <span aria-hidden="true">→</span>
            </Link>
        </article>

        <SectionPanel title={restaurantInfo.name}>
            <SectionCopy paragraphs={[t("cardTextFirst"), t("cardTextSecond")]}/>
        </SectionPanel>
    </section>
); };

export default CardSection;
